import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }

import { ref, reactive, inject, Ref } from 'vue';
  import { IProgram } from '@/types/program';
  import _ from 'lodash';
  import { requestCollection } from '@/utils';
  import { ColorVariants } from '@/constants';
  import ApplyAction from './action.vue';
  import PickupPopup from './pickup-popup.vue';
  import { useI18n } from 'vue-i18n';
  import { usePickupPopup } from '@/hooks/use-pickup-popup';

  interface IProps {
    program: IProgram;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    program: IProgram;
  }

  const { t } = useI18n();
  
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
  const applyActionTeleportNode = inject<Ref<HTMLDivElement>>('applyActionTeleportNode');
  const showApplyAction = inject<() => void>('showApplyAction');
  const hideApplyAction = inject<() => void>('hideApplyAction');
  const dialog = reactive({
    applySuccess: false,
    joinWaitingListSuccess: false,
    error: false,
  });

  const errMessage = ref('');
  const pickupPopupRef = ref();

  // 使用 hook 判断是否应该显示 pickup popup
  const { shouldShowPickupPopup } = usePickupPopup(() => props.program);

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
    hideApplyAction && hideApplyAction();
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
    showApplyAction && showApplyAction();
  }

  const start = () => {
    // 检查是否需要显示 BRITA pickup popup
    // 条件：show_pickup_popup = true 且 minimum_variable_number > 0
    if (shouldShowPickupPopup.value) {
      return showPickupPopup();
    }
    // 原有逻辑：直接调用 apply
    return apply();
  };

  function showPickupPopup() {
    if (pickupPopupRef.value) {
      pickupPopupRef.value.show();
    }
  }

  function handlePickupConfirm(variableNumber: number) {
    // 用户确认数量，调用 apply 并传入数量
    apply(variableNumber);
  }

  function handlePickupCancel() {
    // 用户取消，不执行任何操作
  }

  async function apply(variableNumber?: number) {
    try {
      const result = await requestCollection(props.program, variableNumber);
      if (result) {
        await refreshPageData();
        if (result.status === 'success') {
          showDialog('applySuccess');
        }
        if (result.status === 'wait_list') {
          showDialog('joinWaitingListSuccess');
        }
      }
    } catch (e) {
      const errorMsg = _.get(e, 'message');
      errMessage.value = errorMsg;
      showDialog('error');
    }
  }

  expose({
    start
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, {
      to: _unref(applyActionTeleportNode) ? _unref(applyActionTeleportNode) : 'body'
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
        visible: _unref(dialog).applySuccess,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).applySuccess) = $event))
      }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        btns: [
        { text: _unref(t)('on_going_program_apply_success_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ]
      }), {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('on_going_program_apply_success_content')), 1)
        ]),
        _: 1
      }, 16, ["visible", "btns"])),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
        visible: _unref(dialog).joinWaitingListSuccess,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).joinWaitingListSuccess) = $event))
      }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        content: _unref(t)('on_going_program_join_waiting_list_success_content'),
        btns: [
        { text: _unref(t)('on_going_program_join_waiting_list_success_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ]
      }), null, 16, ["visible", "content", "btns"])),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps({
        visible: _unref(dialog).error,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).error) = $event)),
        content: errMessage.value
      }, _unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        btns: [
        { text: _unref(t)('on_going_program_dialog_error_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() },
      ]
      }), null, 16, ["visible", "content", "btns"]))
    ], 8, ["to"])),
    (_unref(shouldShowPickupPopup))
      ? (_openBlock(), _createBlock(PickupPopup, {
          key: 0,
          ref_key: "pickupPopupRef",
          ref: pickupPopupRef,
          "minimum-number": props.program.minimum_variable_number || 12,
          onConfirm: handlePickupConfirm,
          onCancel: handlePickupCancel
        }, null, 8, ["minimum-number"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})